import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'ADVOCACY_UPDATE',
    smsDelete : 'ADVOCACY_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        category: [],
        advocacy: [],
        advocacy_details: {},
        
        submitSuccess: false,
        categoryLoading: false,
        categoryError: false,
        advocacyLoading: false,
        advocacyError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_CATEGORY(state, results) {
            state.category = results;
        },

        CATEGORY_LOADING (state, loading) {
            state.categoryLoading = loading;
        },

        CATEGORY_ERROR (state, hasError) {
            state.categoryError = hasError;
        },

        SET_ADVOCACY(state, results) {
            state.advocacy = results;
        },

        GET_ADVOCACY_DETAILS(state, results) {
            state.advocacy_details = results;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        ADVOCACY_LOADING (state, loading) {
            state.advocacyLoading = loading;
        },

        ADVOCACY_ERROR (state, hasError) {
            state.advocacyError = hasError;
        }
    },

    actions: {
        // Category 
        async addCategory ({commit, dispatch}, payload) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_advocacy_category, payload.category, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCategory')
                return response

            } catch (e) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async fetchCategory ({ commit }) {
            commit('CATEGORY_LOADING', true);
            commit('CATEGORY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.advocacy_category_list, config);
                let response = result.data.data
                commit('SET_CATEGORY', response);
                return result
            } catch(error) {
                commit('CATEGORY_ERROR', true);
            } finally {
                commit('CATEGORY_LOADING', false);
            }
        },

        async deleteCategory({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_advocacy_category + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCategory')
            return response
        },

        // Advocacy
        async addAdvocacy ({commit, dispatch}, payload) {
            commit('ADVOCACY_LOADING', true);
            commit('ADVOCACY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_advocacy, payload.advocacy, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAdvocacy')
                return response

            } catch (e) {
                commit('ADVOCACY_ERROR', true);
            } finally {
                commit('ADVOCACY_LOADING', false);
            }
        },

        async fetchAdvocacy ({ commit }) {
            commit('ADVOCACY_LOADING', true);
            commit('ADVOCACY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.advocacy_list, config);
                let response = result.data.data
                commit('SET_ADVOCACY', response);
                return result
            } catch(error) {
                commit('ADVOCACY_ERROR', true);
            } finally {
                commit('ADVOCACY_LOADING', false);
            }
        },

        async getDetails ({ commit }, payload) { 
            let response = await axios.get(V1API.get_advocacy_details + payload).then(result => {
                let items = result.data.data
                commit('GET_ADVOCACY_DETAILS', items)
                return result
            })
            return response
        },

        async updateAdvocacy ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_advocacy + payload.id, payload.advocacy, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAdvocacy')
                return response

            } catch (e) {
                commit('ADVOCACY_ERROR', true);
            } finally {
                commit('ADVOCACY_LOADING', false);
            }
        },

        async deleteAdvocacy({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_advocacy + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAdvocacy')
            return response
        },

        async toggleFeatured ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_advocacy_featured + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAdvocacy')
                return response

            } catch (e) {

            } finally {

            }
        }
    },

    getters: {}
}
